// extracted by mini-css-extract-plugin
export var active = "carousel-module--active--tMGiv";
export var carousel = "carousel-module--carousel--uym5U";
export var carouselItem = "carousel-module--carousel-item--D5W7Z";
export var indicators = "carousel-module--indicators--plw7g";
export var inner = "carousel-module--inner--D3zyh";
export var navIcon = "carousel-module--nav-icon--9cyR7";
export var navigateLeft = "carousel-module--navigate-left--7sl+j";
export var navigateRight = "carousel-module--navigate-right--sMTf+";
export var wrapper = "carousel-module--wrapper--O59lP";